import { createContext } from 'react'
import { useSPSamplesSectionContent } from '../hooks'

export const SpSamplesTabContext =
  createContext<ReturnType<typeof useSPSamplesSectionContent>>(null)
